import React, { useContext, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { ApiContext } from '../../../UseContext/ApiCall';
import { BASE_URL_STATIC } from '../../../../../config';


const CnpSelectMusicPopup = () => {

  const {
    cnpSelectedLocation, setCnpSelectedLocation,
    cnpSelectedTextBackground,
    handleCnpOpenPreviousPopup,

    showCnpSelectMusicPopup, setShowCnpSelectMusicPopup,
    showMusicLoadMore, setShowMusicLoadMore,
    cnpMusics,
    cnpSearchedMusics, setCnpSearchedMusics,
    cnpSelectedMusic, setCnpSelectedMusic,
    cnpMusicSearchText, setCnpMusicSearchText,
    getMusics,
  } = useContext(ApiContext);

  // console.log('cnpMusics : ', cnpMusics);
  // console.log('cnpMusicSearchText : ', cnpMusicSearchText);

  // handle search change
  const handleSearchChange = (e) => {
    const { name, value } = e.target;

    console.log('search : ', name, value);

    if(value === '') {
      setCnpSearchedMusics([]);
    } else {
      setCnpMusicSearchText(value);
  
      getMusics(value, cnpSearchedMusics.length, 5);
    };
  };

  // format music duration from seconds to MM:SS
  const formatMusicDuration = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  // ----- Play/Pause -----

  const [playingTrackId, setPlayingTrackId] = useState(null);

  const audioRef = useRef(new Audio());

  // handle play/pause
  const handlePlayPauseMusic = (value) => {
    if (playingTrackId === value.id) {
      audioRef.current.pause();
      setPlayingTrackId(null);
    } else {
      audioRef.current.src = value.audio;
      audioRef.current.play();
      setPlayingTrackId(value.id);
    }
  };

  // handle select music
  const handleSelectMusic = (value) => {

    setCnpSelectedMusic({
      id: value.id,
      image: value.image,
      name: value.name,
      album_name: value.album_name,
      artist_name: value.artist_name,
      duration: value.duration,
      audio: value.audio,
      musicImage: cnpSelectedTextBackground === '' ? true : false,
    });

    audioRef.current.pause();

    setPlayingTrackId(null);

    // Hide location image
    if(cnpSelectedLocation.placeImage) {
      setCnpSelectedLocation(preState => ({
        ...preState,
        placeImage: false
      }));
    };

    handleCloseMusicPouup();
  };

  // handle remove music
  const handleRemoveMusic = () => {
    setCnpSelectedMusic({});

    // show location image if location selected when user remove music
    if((cnpSelectedTextBackground === '') && (cnpSelectedLocation.place !== '' && cnpSelectedLocation.lat !== null && cnpSelectedLocation.lng !== null)) {
      setCnpSelectedLocation(preState => ({
        ...preState,
        placeImage: true
      }));
    };
  };

  // handle load more
  const handleLoadMore = () => {
    setShowMusicLoadMore(false);

    if(cnpMusicSearchText === '') {
      getMusics('', cnpMusics.length, 10);
    } else {
      getMusics(cnpMusicSearchText, cnpSearchedMusics.length, 10);
    };
  };


  // handle close music popup
  const handleCloseMusicPouup = () => {
    audioRef.current.pause();
    
    setPlayingTrackId(null);

    setShowCnpSelectMusicPopup(false);

    handleCnpOpenPreviousPopup();
  };


  return (
    <>
      <Modal show={showCnpSelectMusicPopup} onHide={handleCloseMusicPouup} centered backdrop="static" keyboard={false} className="main-modal" >
      {/* <Modal show={true} onHide={handleCloseMusicPouup} centered backdrop="static" keyboard={false} className="main-modal" > */}
        <Modal.Header className='pt-0' closeButton>
          <h5 className='flex-grow-1 text-center pt-3 mb-0'>Music</h5>
        </Modal.Header>

        <Modal.Body className='pt-1'>
          {/* Search */}
          <div className="d-flex flex-grow-1 rounded-pill bg-body-secondary p-1 p-sm-2 my-3">
            <img className="mx-2" src={`${BASE_URL_STATIC}/icon/search.svg`} alt="search" />

            <input type="search" className="rounded-pill bg-body-secondary w-100 border-0" id="search" name="search" autoComplete='false' placeholder="Search Musics..." 
              value={cnpMusicSearchText} onChange={handleSearchChange}
            />
          </div>

          {/* Selected Music */}
          <>
            {
              (cnpSelectedMusic && cnpSelectedMusic.id && cnpSelectedMusic.id !== '')
              &&
              <div className='d-flex align-items-center gap-3 mb-2 py-1 ps-1 rounded-2' style={{ background: "linear-gradient(90deg, rgb(0 99 255), rgb(0 99 255 / 84%), rgb(0 109 255 / 0%))" }} >
                <img src={cnpSelectedMusic.image} className='border rounded-circle cursor-pointer' style={{ height: '40px', width: '40px' }} onClick={() => handlePlayPauseMusic(cnpSelectedMusic)} alt="profile" />

                <div className='w-50 me-auto cursor-pointer' onClick={() => handlePlayPauseMusic(cnpSelectedMusic)}>
                  <h6 className={`text-white mb-0 text-truncate`}>{`${cnpSelectedMusic.name} (${cnpSelectedMusic.album_name})`}</h6>
                  <div className={`text-white d-flex align-items-baseline gap-1`}>
                    <span className='text-truncate'>{cnpSelectedMusic.artist_name}</span> 
                    ● 
                    <span>{formatMusicDuration(cnpSelectedMusic.duration)}</span>
                  </div>
                </div>

                {/* Play/Pause */}
                <img src={playingTrackId === cnpSelectedMusic.id ? "/images/icons/pause-circle.svg" : "/images/icons/play-circle.svg"} alt={playingTrackId === cnpSelectedMusic.id ? "Pause" : "Play"}
                  className="cursor-pointer" style={{ height: "27px", width: "27px" }} onClick={() => handlePlayPauseMusic(cnpSelectedMusic)}
                />
                
                {/* Add */}
                <img src="/images/icons/close-circle.svg" className='cursor-pointer' style={{ height: '27px', width: '27px' }} onClick={handleRemoveMusic} alt="pause" />
              </div>
            }
          </>


          {/* Show > Musics & Searched Musics */}
          <>
            {
              (cnpSearchedMusics && cnpSearchedMusics.length > 0)
              ?
              // Searched Musics
              <div className={`${cnpSearchedMusics.length > 5 && 'overflow-y-scroll'} pe-2`} style={{ maxHeight: '50vh' }}>
                {
                  cnpSearchedMusics.map((value, index) => (
                    <>
                      {
                        value.id !== cnpSelectedMusic.id
                        &&
                        <div className='d-flex align-items-center gap-3 mb-2 py-1 ps-1 rounded-2' key={index}
                          style={{ background: value.id === playingTrackId ? "linear-gradient(90deg, rgb(0 99 255), rgb(0 99 255 / 84%), rgb(0 109 255 / 0%))" : "transparent" }}
                        >
                          <img src={value.image} className='border rounded-circle cursor-pointer' style={{ height: '40px', width: '40px' }} onClick={() => handlePlayPauseMusic(value)} alt="profile" />

                          <div className='w-50 me-auto cursor-pointer' onClick={() => handlePlayPauseMusic(value)}>
                            <h6 className={`${value.id === playingTrackId ? 'text-white' : 'text-dark'} mb-0 text-truncate`}>{`${value.name} (${value.album_name})`}</h6>
                            <div className={`${value.id === playingTrackId ? 'text-white' : 'text-secondary'} d-flex align-items-baseline gap-1`}>
                              <span className='text-truncate'>{value.artist_name}</span> 
                              ● 
                              <span>{formatMusicDuration(value.duration)}</span>
                            </div>
                          </div>

                          {/* Play/Pause */}
                          <img src={playingTrackId === value.id ? "/images/icons/pause-circle.svg" : "/images/icons/play-circle.svg"} alt={playingTrackId === value.id ? "Pause" : "Play"}
                            className="cursor-pointer" style={{ height: "27px", width: "27px" }} onClick={() => handlePlayPauseMusic(value)}
                          />

                          {/* Add */}
                          <img src="/images/icons/add-circle.svg" className='cursor-pointer' style={{ height: '27px', width: '27px' }} onClick={() => handleSelectMusic(value)} alt="pause" />
                        </div>
                      }
                    </>
                  ))
                }

                {
                  showMusicLoadMore
                  &&
                  <div className='text-center'>
                    <button type="button" className='btn btn-primary btn-sm mt-3 mb-1' onClick={handleLoadMore}>Load More</button>
                  </div>
                }
              </div>
              :
              // Musics
              <div className={`${cnpMusics.length > 5 && 'overflow-y-scroll'} pe-2`} style={{ maxHeight: '50vh' }}>
                { 
                  (cnpMusics && cnpMusics.length > 0)
                  ?
                  <>
                    {
                      cnpMusics.map((value, index) => (
                        <>
                          {
                            value.id !== cnpSelectedMusic.id
                            &&
                            <div className='d-flex align-items-center gap-3 mb-2 py-1 ps-1 rounded-2' key={index}
                              style={{ 
                                background: value.id === playingTrackId ? "linear-gradient(90deg, rgb(0 99 255), rgb(0 99 255 / 84%), rgb(0 109 255 / 0%))" : "transparent", 
                              }}
                            >
                              <img src={value.image} className='border rounded-circle cursor-pointer' style={{ height: '40px', width: '40px' }} onClick={() => handlePlayPauseMusic(value)} alt="profile" />

                              <div className='w-50 me-auto cursor-pointer' onClick={() => handlePlayPauseMusic(value)}>
                                <h6 className={`${value.id === playingTrackId ? 'text-white' : 'text-dark'} mb-0 text-truncate`}>{`${value.name} (${value.album_name})`}</h6>
                                <div className={`${value.id === playingTrackId ? 'text-white' : 'text-secondary'} d-flex align-items-baseline gap-1`}>
                                  <span className='text-truncate'>{value.artist_name}</span> 
                                  ● 
                                  <span>{formatMusicDuration(value.duration)}</span>
                                </div>
                              </div>

                              {/* Play/Pause */}
                              <img src={playingTrackId === value.id ? "/images/icons/pause-circle.svg" : "/images/icons/play-circle.svg"} alt={playingTrackId === value.id ? "Pause" : "Play"}
                                className="cursor-pointer" style={{ height: "27px", width: "27px" }} onClick={() => handlePlayPauseMusic(value)}
                              />
                              {/* Add */}
                              <img src="/images/icons/add-circle.svg" className='cursor-pointer' style={{ height: '27px', width: '27px' }} onClick={() => handleSelectMusic(value)} alt="pause" />
                            </div>
                          }
                        </>
                      ))
                    }

                    {
                      showMusicLoadMore
                      &&
                      <div className='text-center'>
                        <button type="button" className='btn btn-primary btn-sm mt-3 mb-1' onClick={handleLoadMore}>Load More</button>
                      </div>
                    }
                  </>
                  :
                  <div className='text-center text-secondary'>Loading...</div>
                }
              </div>
            }
          </>

        </Modal.Body>
      </Modal>
    </>
  );
};

export default CnpSelectMusicPopup;